import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn, H3, P } from "../../../../../AbstractElements";
import { Paperclip } from "react-feather";

//FORM
import UploadAttachmentForm from "./UploadAttachmentForm";

interface ModalProps {
  EmpNo: string;
}

const UploadAttachments: React.FC<ModalProps> = ({ EmpNo }) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <div className="d-flex justify-content-end">
        <Btn
          color="info"
          onClick={toggle}
          style={{ display: "flex", alignItems: "center", gap: "2px" }}
        >
          <Paperclip size={16} className="me-1" />
          Attach Files
        </Btn>
      </div>
      <br></br>

      <Modal
        size="lg"
        isOpen={modal}
        toggle={toggle}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0 mb-0">
            <H3>Upload Attachments</H3>
            <button onClick={toggle} className="btn-close"></button>
            <P className="mb-0">
              Attach the necessary documents to support your employee 201 file.
            </P>
          </ModalHeader>
          <UploadAttachmentForm EmpNo={EmpNo} toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};

export default UploadAttachments;
